import { Instagram, Sparkles } from 'lucide-react';

const INSTAGRAM_URL = 'https://instagram.com/raojatin.in';

export default function FloatingInstagramButton() {
  return (
    <a
      className="floating-instagram"
      href={INSTAGRAM_URL}
      target="_blank"
      rel="noreferrer"
      aria-label="Open Instagram profile @raojatin.in"
    >
      <span className="floating-instagram-spark" aria-hidden="true">
        <Sparkles size={12} />
      </span>
      <Instagram size={16} />
      <span className="floating-instagram-text">@raojatin.in</span>
    </a>
  );
}
